export default {
  title: {
    en: "Wallet is not connected",
    ja: "ウォレットが接続されていない"
  }
}
